import React from 'react';
import { useTranslation } from 'react-i18next';

import { View } from '@actual-app/components/view';

import { Page } from '#components/Page';

import { cor, espaco } from './estilo';

export function Investimentos() {
  const { t } = useTranslation();

  return (
    <Page header={t('Investimentos')}>
      <View
        style={{
          backgroundColor: cor.fundo,
          gap: espaco.entreBlocos,
          padding: espaco.entreBlocos,
        }}
      >
        {/* A Task 16 preenche esta tela */}
      </View>
    </Page>
  );
}
